import { Suspense } from 'react';
import PageErrorBoundary from '#/_packages/umbrella/features/error-handling/components/page-error-boundry';
import UmbrellaErrorRouteComponent from '#/_packages/umbrella/features/error-handling/components/umbrella-error-component';
import { EventPagesContext } from '#/_packages/umbrella/features/events/event-pages-context';
import { NewsPagesContext } from '#/_packages/umbrella/features/news/news-pages-context';
import type { ContentRouteLoaderData } from '#/_packages/umbrella/features/routing/types/types';
import { getCurrentContentCulture } from '#/_packages/umbrella/features/routing/utils/content-route-utils';
import DocTypeRenderer from '#/_packages/umbrella/integrations/umbraco/utils/content-renderer';

type ContentRouteViewProps = {
    loaderData: ContentRouteLoaderData;
    onReset: () => void;
};

export function ContentRouteView({ loaderData, onReset }: ContentRouteViewProps) {
    if (loaderData.isError) {
        return (
            <UmbrellaErrorRouteComponent
                error={loaderData.loaderError as Error}
                reset={onReset}
            />
        );
    }

    return (
        <PageErrorBoundary>
            <input
                type='hidden'
                name='contentLang'
                id='contentLang'
                value={getCurrentContentCulture(loaderData.content)}
            />
            <Suspense>
                <EventPagesContext value={loaderData.eventPages}>
                    <NewsPagesContext value={loaderData.newsPages}>
                        <DocTypeRenderer
                            content={loaderData.content}
                            breadcrumbs={loaderData.breadCrumbs}
                        />
                    </NewsPagesContext>
                </EventPagesContext>
            </Suspense>
        </PageErrorBoundary>
    );
}
